import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { forwardRef } from "react";

interface Props extends React.ComponentPropsWithoutRef<"div"> {
  container?: HTMLElement | null;
  onClickOutside?: (e: any) => void;
}

export const Portal = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { container = window.document.body, onClickOutside, ...rest } = props;
  const _ref = useRef<any>(null);

  const handleClick = (e: any) => {
    if (!!_ref.current && _ref.current.contains(e.target)) return;
    !!onClickOutside && onClickOutside(e);
  };

  useEffect(() => {
    if (!ref) return;
    _ref.current = (ref as any).current;
  }, [ref]);

  useEffect(() => {
    if (!!onClickOutside) {
      window.document.body.addEventListener("click", handleClick);
    }
    return () => {
      if (!!onClickOutside) {
        window.document.body.removeEventListener("click", handleClick);
      }
    };
  }, [onClickOutside]);

  return container
    ? createPortal(<div {...rest} ref={_ref} />, container)
    : null;
});

Portal.displayName = "Portal";
